import 'magnific-popup';
jQuery( document ).ready(function($) {
    $('.mfp-inline').magnificPopup({})
});